// sortAiSessions.js — Recents ordering for Sessions panel

import {
  isAiConversation,
} from 'channels/constants/channelTypes';
import {
  isAiChannelKeyForUser,
  isAiSessionVisibleInRecents,
} from 'spaces/utils/aiChannelKeys';

function toMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  const asDate = value instanceof Date ? value : new Date(value);
  const ms = asDate.getTime();
  return Number.isFinite(ms) ? ms : 0;
}

export function compareAiSessions(a, b) {
  const aPinned = a?.pinned === true;
  const bPinned = b?.pinned === true;
  if (aPinned !== bPinned) return aPinned ? -1 : 1;

  if (aPinned && bPinned) {
    const pinDiff = toMillis(b?.pinnedAt) - toMillis(a?.pinnedAt);
    if (pinDiff !== 0) return pinDiff;
  }

  const activityDiff = toMillis(b?.lastMessageAt) - toMillis(a?.lastMessageAt);
  if (activityDiff !== 0) return activityDiff;

  return String(a?.title || '').localeCompare(String(b?.title || ''));
}

export function buildAiSessionsList({
  channels = [],
  baseKey,
  userKey,
} = {}) {
  return (Array.isArray(channels) ? channels : [])
    .filter((channel) => {
      if (!isAiConversation(channel)) return false;
      if (!isAiChannelKeyForUser(channel?.key, baseKey, userKey)) return false;
      return isAiSessionVisibleInRecents(channel, baseKey, userKey);
    })
    .slice()
    .sort(compareAiSessions);
}
